import React, { useEffect, useRef, useState } from 'react'
import SingleAnalyticsHeader from '../student/SingleAnalyticsHeader'
import { useTranslation } from 'react-i18next'
import CounsellorCardWidget from './CounsellorCardWidget'
import CounsellorAnalyticsWidgets from './CounsellorAnalyticsWidgets'
import { usePageTitle } from '../../../utils/util'
import DayFilteringWidget from '../student/DayFilteringWidget'
import { daysFilterList } from '../class/ClassAnalyticsWidgets'
import { useAnalyticsUrlFilters } from '../useAnalyticsUrlFilters'

function CounsellorAnalyticsHome() {
    const { t } = useTranslation()
    const { selectedOptions, setSelectedOptions, daysFilter, setDaysFilter } = useAnalyticsUrlFilters()
    const [showFilter, setShowFilter] = useState(false)

    const widgetsRef = useRef(null)
    const scrollRef = useRef(null)

    usePageTitle(`Upstrive Education - Counsellor Analytics`)

    useEffect(() => {
        const handleScroll = () => {
            if (scrollRef.current) {
                const scrollTop = scrollRef.current.scrollTop
                setShowFilter(scrollTop > 100)
            }
        }

        const widgetsElement = scrollRef.current
        if (widgetsElement) {
            widgetsElement.addEventListener('scroll', handleScroll)

            // Initial check
            handleScroll()
        }

        return () => {
            if (widgetsElement) {
                widgetsElement.removeEventListener('scroll', handleScroll)
            }
        }
    }, [scrollRef.current])

    return (
        <div id="studentAnalyticsId" className="page-shell flex flex-col flex-1 min-h-0 bg-lightBG overflow-y-auto">
            <div className="max-w-[1360px] mx-[auto] w-full ">
                <SingleAnalyticsHeader />

                <div className="mt-[10px] flex flex-row items-center justify-between gap-[15px]">
                    <p className="page-title text-darkenPurple font-semibold truncate">
                        {t('Counsellor analytics')}
                    </p>
                    <div
                        className="transition-all duration-300 ease-in-out"
                        style={{
                            opacity: showFilter ? 1 : 0,
                            visibility: showFilter ? 'visible' : 'hidden',
                            transform: showFilter ? 'translateY(0)' : 'translateY(-10px)',
                            zIndex: 4,
                        }}
                    >
                        <DayFilteringWidget daysFilter={daysFilter} daysFilterList={daysFilterList} setDaysFilter={setDaysFilter} />
                    </div>
                </div>

                <div className="w-full border-b border-b-white mt-5"></div>

                <div className="flex flex-row items-stretch xl:gap-6 transition-all " style={{ minHeight: 'max(685px, calc(100vh - 160px))' }}>
                    <div className="pt-[20px] w-auto min-h-full" data-tour="class-card">
                        <CounsellorCardWidget setSelectedOptions={setSelectedOptions} selectedOptions={selectedOptions} />
                    </div>
                    <div className="flex-1 relative" data-tour="analytics-widgets" id="analytics-widgets">
                        <div className="absolute inset-0 overflow-y-auto" ref={scrollRef}>
                            <CounsellorAnalyticsWidgets selectedOptions={selectedOptions} daysFilter={daysFilter} setDaysFilter={setDaysFilter} />
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default CounsellorAnalyticsHome
